import { Directive, ElementRef, HostListener } from '@angular/core';
@Directive({
  selector: '[appRemoveWhiteSpace]'
})
export class WhitespaceRemoveDirective {

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event'])
  onInputChange(event: Event): void {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    const trimmedValue = inputElement.value.replace(/^\s+/, '').replace(/\./g, ' ');
    const newValue = trimmedValue.replace(/\s\s+/g, ' ').replace(/\./g, ' ').replace(/[^\w\s]/gi, '');
    if (inputElement.value !== newValue) {
      inputElement.value = newValue;
    }
  }

}
